<template>
  <div class="head-container">
    <div class="head-box">
      <div class="logo-box">
        <img src="../../assets/newImg/logo.png" alt="" class="logo" />
        <div class="search" v-if="$route.path == '/'">
          <input
            type="text"
            v-model="queryParams.sercherName"
            placeholder="请输入职位或企业名称"
          />
          <el-button @click="seachButton()">搜索</el-button>
        </div>
        <!-- <div v-if="$route.path == '/'">
                    <div class="search">
                        <input type="text" v-model="queryParams.sercherName" placeholder="请输入职位或企业名称" />
                        <el-button @click="seachButton()">搜索</el-button>
                    </div>
                    <div>
                        <div class="carouselNotice">
                            <el-carousel height="20px" direction="vertical" :autoplay="true" :interval="5000"
                                indicator-position="none">
                                <el-carousel-item v-for="item in annunciateNoticeList" :value="item.id" :label="item.unit"
                                    :key="item.value">
                                    <h3>
                                        <img class="noticeImg" src="static/img/systemNotice.png">
                                        <a class="aNotice" @click="goTo(item.id, item.status)">
                                            {{ item.unit }}
                                        </a>
                                    </h3>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div> -->
        <div class="user-box">
          <img src="../../assets/newImg/user.png" alt="" class="user" />
          <!-- <span>登录</span>／
                    <span>注册</span> -->
          <router-link to="/login" v-if="!user" style="text-decoration: none"
            ><span>登录 / 注册</span></router-link
          >
          <el-dropdown v-else>
            <router-link
              to="/mine"
              style="
                text-decoration: none;
                color: rgb(64, 71, 86);
                font-family: PingFang SC;
                font-size: 18px;
              "
              >{{ this.$cookies.get(this.$commons.User.userName) }}</router-link
            >
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><router-link to="/mine" v-if="user"
                  ><span>个人中心</span></router-link
                ></el-dropdown-item
              >
              <el-dropdown-item>
                <a v-if="user" @click="logout"><span>退出</span></a></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <router-link to="/mine" v-else>{{
                        this.$cookies.get(this.$commons.User.userName)
                    }}</router-link>

                    <ul v-if="user" class="user-center">
                        <li>
                            <router-link
                                to="/mine"
                                style="cursor: pointer"
                                v-if="user"
                                ><span>个人中心</span></router-link
                            >
                        </li>
                        <li>
                            <a
                                v-if="user"
                                @click="logout"
                                style="cursor: pointer"
                                ><span>退出</span></a
                            >
                        </li>
                    </ul> -->
          <!-- <h6>123</h6> -->
        </div>
      </div>
      <div class="nav-box">
        <a
          @click="handleCutRoute(0, '/')"
          class="nav-item"
          :class="{ active: currentIndex == 0 }"
          >首页
        </a>
        <a
          @click="handleCutRoute(1, '/recruitList', { category: 1 })"
          class="nav-item"
          :class="{
            active: currentIndex == 1,
          }"
          >政企招聘
        </a>
        <a
          @click="handleCutRoute(2, '/recruitList', { category: 4 })"
          class="nav-item"
          :class="{
            active: currentIndex == 2,
          }"
          >劳务派遣
        </a>
        <a
          @click="handleCutRoute(3, '/recruitList', { category: 5 })"
          class="nav-item"
          :class="{
            active: currentIndex == 3,
          }"
          >劳务外包
        </a>
        <a
          @click="handleCutRoute(4, '/recruitList', { category: 2 })"
          class="nav-item"
          :class="{
            active: currentIndex == 4,
          }"
          >校园招聘
        </a>
        <a
          @click="handleCutRoute(5, '/recruitList', { category: 3 })"
          class="nav-item"
          :class="{
            active: currentIndex == 5,
          }"
          >高端猎聘
        </a>
        <a
          @click="handleCutRoute(6, '/recruitList', { category: 6 })"
          class="nav-item"
          :class="{
            active: currentIndex == 6,
          }"
          >企业招聘</a
        >
<!--         <a
          @click="handleCutRoute(7, '/server')"
          class="nav-item"
          :class="{ active: currentIndex == 7 }"
          >培训服务
        </a>-->


<!--       <a @click="handleCutRoute(10, '/recruitmentIndex', { category: 2 })" class="nav-item" :class="{
            active: currentIndex == 10,
          }">校园招聘
        </a>-->
        <!-- <a
          @click="handleCutRoute(7, '/specialist')"
          class="nav-item"
          :class="{
            active: currentIndex == 7,
          }"
          >专家库</a
        >
        <a
          @click="handleCutRoute(8, '/adviser')"
          class="nav-item"
          :class="{ active: currentIndex == 8 }"
          >留学服务
        </a> -->
        <a
          @click="handleCutRoute(9, '/mine')"
          class="nav-item"
          :class="{ active: currentIndex == 9 }"
          >个人中心
        </a>
        <!-- <a
          @click="handleCutRoute(10, '/specialist')"
          class="nav-item"
          :class="{ active: currentIndex == 10 }"
          >找老师
        </a> -->
      </div>
    </div>

    <el-dialog
      :title="this.title"
      :visible.sync="seacherOpen"
      :fullscreen="true"
      :before-close="handleClose"
    >
      <div class="search-res">
        <div class="left-box-two" v-if="recruitNoticeList.length > 0">
          <div class="res-item" v-for="(item, index) in recruitNoticeList" :key="index">
            <div class="top-res">
              <div class="title-two">
                {{ item.title }}
              </div>
              <div class="date-two">发布时间: {{ item.publishTime }}</div>
            </div>
            <div class="top-res">
              <div class="type">
                当前阶段: {{ item.statusName }} | 招聘岗位:
                <span> {{ item.postNum }}</span> | 招聘人数:
                <span> {{ item.totalNumber }}</span>
              </div>
              <div
                :class="item.status == 2 ? 'button-over' : 'button-start'"
                @click="goTo(item.id, item.status)"
              >
                {{ item.statusName }}
              </div>
            </div>
          </div>
        </div>
        <div v-else style="width: 100%">
          <el-divider content-position="center">暂无数据</el-divider>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchShow: true,
      currentIndex: 0,
      user: false,
      annunciateNoticeList: [],
      recruitNoticeList: [],
      title: "",
      dictList: [],
      seacherOpen: false,
      queryParams: {
        sercherName: "",
      },
    };
  },
  watch: {
    $route(to, from) {
      this.user = !!this.$cookies.get(this.$commons.User.Authentication);
    },
  },
  updated() {
    this.user = !!this.$cookies.get(this.$commons.User.Authentication);
  },
  mounted() {},
  created() {
    this.informNoticeList();
    if (this.$route.name == "recruitList" && this.$route.query.category) {
      var category = this.$route.query.category;
      if (category == 1) {
        this.current = 1;
      }
      if (category == 4) {
        this.current = 2;
      }
      if (category == 5) {
        this.current = 3;
      }
      if (category == 2) {
        this.current = 4;
      }
      if (category == 3) {
        this.current = 5;
      }
      if (category == 6) {
        this.current = 6;
      }
      // if (category == 7) {
      //   this.current = 7;
      // }
    }
    else if (this.$route.name == "server") {
      this.current = 7;
    }
    else if (this.$route.name == "adviser") {
      this.current = 6;
    } else if (this.$route.name == "home") {
      this.current = 0;
    } else {
      console.log("this.$route.name", this.$route.name);
      this.current = null;
    }
    this.user = !!this.$cookies.get(this.$commons.User.Authentication);
  },
  methods: {
    /** 搜索按钮 */
    seachButton() {
      const param = {
        ...this.queryParams,
      };
      this.title = this.queryParams.sercherName;
      this.seacherOpen = true;
      this.$api.recruitNotice.getSeacherButton(param).then((response) => {
        if (response.code == this.$commons.RespCode.success) {
          this.recruitNoticeList = response.data;
          if (this.dictList.length > 0) {
            this.handleData();
          } else {
            this.getByDicType();
          }
          this.total = Number(response.total);
        }
        // this.recruitNoticeList = response.data;
        // if (this.dictList.length > 0) {
        //     this.handleData();
        // } else {
        //     this.getByDicType();
        // }
        // this.total = Number(response.total);
      });
    },
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
          // done();
          this.seacherOpen = false;
        })
        .catch((_) => {});
    },
    handleData() {
      let _this = this;
      _this.recruitNoticeList.forEach((item) => {
        _this.dictList.forEach((dic) => {
          if (dic.dictValue == item.status) {
            _this.$set(item, "statusName", dic.dictLabel);
          }
        });
      });
    },
    getByDicType() {
      let _this = this;
      let param = {
        dictType: "re_notice_status",
      };
      _this.$api.system
        .getDicByCode(param)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            this.dictList = res.data;
            this.handleData();
          }
        })
        .catch(() => {});
    },
    // goDetail(item) {
    //     console.log("item", item);
    //     let _this = this;
    //     if (item.sourceType == 3) {
    //         _this.$router.push({
    //             path: "/newsDetail",
    //             query: { id: item.linkUrl },
    //         });
    //     } else if (item.sourceType == 2) {
    //         _this.$router.push({
    //             path: "/recruitDetail",
    //             query: { id: item.linkUrl },
    //         });
    //     } else if (item.sourceType == 1) {
    //         window.open(item.linkUrl, "_blank");
    //     }
    // },
    goBaoming(item) {
      this.$router.push({
        path: "/recruitDetail",
        query: { id: item.noticeId },
      });
    },
    goTo(id, status) {
      // if (status == 1 || status == 0) {
      this.$router.push({ path: "/recruitDetail", query: { id: id } });
      this.seacherOpen = false;
      // }
    },
    /** 首页轮播图展示(暂时隐藏了) */
    informNoticeList() {
      this.$api.recruitNotice.getNoticeList().then((response) => {
        for (let index = 0; index < response.data.length; index++) {
          this.annunciateNoticeList.push({
            id: response.data[index].id,
            unit: response.data[index].unit,
          });
        }
      });
    },
    /** aAnnunciateNoticeList() {
            console.log("点击路由进行跳转");
        },*/
    handleCutRoute(index, path, query = {}) {
      this.currentIndex = index;
      this.$router.push({
        path,
        query,
      });
    },
    logout() {
      let _this = this;
      _this.$layer.confirm(
        "您确定要退出吗？",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          $.get(_this.$config.baseUrl + "/auth/logoutPc", function (res) {
            if (res.code == 200) {
              _this.$cookies.remove(_this.$commons.User.Authentication);
              _this.$cookies.remove(_this.$commons.User.userName);
              _this.$cookies.remove(_this.$commons.User.identity);
              _this.$layer.close(index);
              _this.user = false;
              if (_this.$router.currentRoute.fullPath == "/") {
                _this.$emit("logoutBack");
              } else {
                _this.$router.push({
                  path: "/",
                });
              }
            }
          });
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
  },
};
</script>

<style scoped>
.head-container {
  background-color: #fff;
  width: 100%;
}

.head-container .head-box {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 24px;
}

.head-container .head-box .logo-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.head-container .head-box .logo-box .logo {
  width: 263px;
  height: 76px;
}

.carouselNotice {
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: left;
  overflow: hidden;
}

.noticeImg {
  margin-top: -3px;
}

.head-container .head-box .logo-box .search {
  display: flex;
  position: relative;
}

.head-container .head-box .logo-box .search input {
  width: 420px;
  height: 55px;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(64, 112, 179);
  padding: 10px;
}

.head-container .head-box .logo-box .search button {
  width: 96px;
  height: 55px;
  background: rgb(64, 112, 179);
  border-radius: 0px 8px 8px 0px;
  color: rgb(255, 255, 255);
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 8px;
}

.head-container .head-box .logo-box .user-box {
  cursor: pointer;
}

.head-container .head-box .logo-box .user-box .user {
  vertical-align: middle;
  margin-right: 10px;
}

.head-container .head-box .logo-box .user-box span {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 18px;
}

.head-container .head-box .nav-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 24px;
}

.head-container .head-box .nav-box .nav-item {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 18px;
  text-decoration: none;
  cursor: pointer;
}

.head-container .head-box .nav-box .nav-item.active {
  color: rgb(64, 112, 179);
  font-weight: 500;
  border-bottom: 3px solid rgb(64, 112, 179);
}

.head-container .head-box .nav-box .nav-item:hover {
  color: rgb(64, 112, 179);
  font-weight: 500;
  border-bottom: 3px solid rgb(64, 112, 179);
  /* transition: all 0.2s; */
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 20px;
  margin: 0;
}

a {
  color: #475669;
}

a:hover {
  text-decoration: none;
}

.search-res {
  max-width: 1200px;
  margin: 24px auto 0px;
  /* display: flex; */
  /* justify-content: space-between; */
}

.search-res .left-box-two {
  width: 79%;
}

.search-res .left-box-two .res-item {
  background-color: #fff;
  padding: 18px 16px;
  margin-bottom: 24px;
}

.search-res .left-box-two .pages {
  text-align: center;
  margin: 50px auto;
}

.search-res .left-box-two .res-item .top-res {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px 20px;
}

.search-res .left-box-two .res-item .top-res .title-two {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.search-res .left-box-two .res-item .top-res .date-two {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
}

.search-res .left-box-two .res-item .top-res .type {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
}

.search-res .left-box-two .res-item .top-res .button-start {
  width: 144px;
  height: 40px;
  background: rgb(64, 112, 179);
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: rgb(255, 255, 255);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.search-res .left-box-two .res-item .top-res .button-over {
  width: 144px;
  height: 40px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(164, 171, 189);
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.search-res .left-box-two .res-item .top-res .type span {
  font-size: 24px;
  color: rgb(64, 112, 179);
}

.search-res .right-box {
  width: 20%;
}

.search-res .right-box img {
  width: 100%;
  margin-bottom: 24px;
  cursor: pointer;
  min-height: 200px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/view/base/head.vue